import { Component, Injector, Input, OnInit } from '@angular/core';
import { BaseModalComponent, EnumValues } from '@card-software/library';
import { Translation } from '../../../../models/translation';
import { LocalHelperService } from '../../../../services/local-helper.service';
import { SupplyRequestEntry } from '../../../../models/supply-request/supply-request-entry';
import { ExternalRequisitionCreate } from '../../../../models/order/external-requisition/external-requisition-create';
import { ExternalRequisitionProxyService } from '../../../../proxies/order/external-requisition.proxy.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { EnumService } from '../../../../services/enum.service';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { ExternalRequisition } from '../../../../models/order/external-requisition/external-requisition';

@Component({
  selector: 'app-requisition-form-modal',
  templateUrl: './requisition-form-modal.component.html',
  styleUrl: './requisition-form-modal.component.scss',
})
export class RequisitionFormModalComponent extends BaseModalComponent<ExternalRequisition | null> implements OnInit {
  @Input() requestedItemsTableData: SupplyRequestEntry[] = [];
  @Input() supplyRequestReference!: string;

  isLoading = false;

  mainForm: FormGroup;

  externalRequisitionPriorityOptions: EnumValues;
  externalRequisitionTypeOptions: EnumValues;

  translations: Record<string, Translation> = {
    Error_Save_Message: {
      en: 'Error saving Requisition',
      es: 'Error al guardar la requisición',
    },
    Add_Requisition: {
      en: "Requisition '{{name}}' Saved",
      es: "Requisición '{{name}}' guardada",
    },
  };

  constructor(
    injector: Injector,
    public localHelperService: LocalHelperService,
    private externalRequisitionProxyService: ExternalRequisitionProxyService,
    public enumService: EnumService,
    private messageService: MessageService,
    private translateService: TranslateService,
  ) {
    super(injector);
    this.mainForm = this.initializeMainForm();
    this.externalRequisitionPriorityOptions = this.enumService.getEnum('ExternalRequisitionPriority', 'order').values;
    this.externalRequisitionTypeOptions = this.enumService.getEnum('ExternalRequisitionType', 'order').values;
  }

  private initializeMainForm(): FormGroup {
    return new FormGroup({
      requisitionType: new FormControl<string | null>(null, Validators.required),
      priority: new FormControl<string | null>(null, Validators.required),
    });
  }

  ngOnInit(): void {
    console.log(this.requestedItemsTableData);
  }

  public _setOptionsForPrimeNg(value: EnumValues) {
    return Object.keys(value).map((key) => {
      const numKey = parseInt(key);
      return {
        label: value[numKey],
        value: numKey,
      };
    });
  }

  canSave(): boolean {
    return this.mainForm.valid || this.isLoading;
  }

  onSave() {
    if (this.mainForm.valid) {
      const formValue = this.mainForm.value;
      const command: ExternalRequisitionCreate = {
        supplyRequestReference: this.supplyRequestReference,
        requisitionType: formValue.requisitionType,
        priority: formValue.priority,
      };

      this.externalRequisitionProxyService.create(command).subscribe({
        next: (result) => {
          if (result.success) {
            this.messageService.add({
              severity: 'success',
              summary: this.translateService.instant('Common_Success'),
            });

            this.close({ action: 'success', data: result.data });
          }
        },
      });
    }
  }

  onClose() {
    this.close({ action: 'close', data: null });
  }
}
